import { useEffect, useState, useMemo } from "react";
import { Routes, Route,useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "context/auth/authSlice";

import { useMaterialUIController, setMiniSidenav, setLayout } from "context";
import { Icon } from "@mui/material";
// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
// Material Dashboard 2 React themes
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";

// Material Dashboard 2 React Dark Mode themes
import themeDark from "assets/theme-dark";
import themeDarkRTL from "assets/theme-dark/theme-rtl";

// RTL plugins
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

import Home from "components/Home";
import Distributers from "components/Home/distributers";
import DistributorPage from "components/Home/distributers/sections";
import DistributorSettings from "dashboard/layouts/distributers/sections/NewDistributer";
import Products from "components/Home/products";
import ProductPage from "components/Home/products/sections/ProductPage";
import ShoppinCartView from "components/sections/product/sections/ShoppinCartView";
import DistributorProduct from "components/sections/product/sections";
import NotFound from "components/Home/Pages/notFound";
import AcountActivation from "components/Author/sections/AcountActivation";
import NewPassword from "components/Author/sections/NewPassword";
import ResetPass from "components/sections/reset-password";
import SignIn from "components/sections/sign-in";
import SignUp from "components/sections/sign-up";
/* users account */
import Profile from "components/Author/profile";
import Orders from "components/sections/orders";
import OrderDetails from "components/sections/orders/sections/orderDetails"

import Alert from "dashboard/components/MDAlert/Alert";
import RequireAuth from "context/auth/RequireAuth";
import PersistLogin from "context/auth/PersistLogin";
import brandDark from "assets/images/logos/granitex-logo-white.png" 
import brandWhite  from "assets/images/logos/granitex-logo.png" 
import Sidenav from "components/layouts/Sidenav";
import "assets/css/style.css"
import "./App.css";

import BasicPages from "components/Home/Pages";

const routes = ()=>(
  <Routes>
    <Route element={<PersistLogin/>} >
      <Route path="/:lang?/">
        <Route  element={<RequireAuth alloawedRoles={[7577,3597,1500]}/>}>
            <Route path="profil" element={<Profile />} />
            <Route path="profil/Commandes" element={<Orders />} />
            <Route path="profil/achâts" element={<Orders />} />
            <Route path="profil/orderDetails/:id" element={<OrderDetails />} />
        </Route>
        <Route  element={<RequireAuth alloawedRoles={[7577,3597]}/>}>
            <Route path="Distibutions/informations" element={<DistributorSettings />} />
            <Route path="Distibutions/ventes" element={<Orders />} />
            <Route path="Distibutions/Commandes-Clients" element={<Orders />} />
            <Route path="Distibutions/Produits" element={<DistributorProduct />} />
        </Route>
        <Route path="distributer/:type" element={<SignUp />} />
        <Route path="distributors" >
          <Route index element={<Distributers />} />
          <Route path=":id" element={<DistributorPage />}/>
        </Route>
        <Route path="products" element={<Products />} />
        <Route path="product/:id" element={<ProductPage />} />
        <Route path="products/:category" element={<Products />} />
        <Route path="Checkout/ShoppingCart">
          <Route index element={<ShoppinCartView />} />
          <Route path=":phase" element={<ShoppinCartView />} />
        </Route>
        <Route path="authentication/sign-in" element={<SignIn />} />
        <Route path="authentication/sign-up" element={<SignUp />} />
        <Route path="activate/:id/:rand" element={<AcountActivation />} />
        <Route path="authentication/NewPass" element={<NewPassword />}>
          <Route path=":token" element={<NewPassword />} />
          <Route path="*" element={<NewPassword />} />
        </Route>
        <Route path="authentication/ResetPass" element={<ResetPass />} />
        <Route exact path="navigate/:url" element={<BasicPages />} />
        <Route path=":slug" element={<Home />} />
        <Route index element={<Home />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Route>
</Routes>
)
const App = () => {
  const { pathname } = useLocation();
  const [controller, dispatch] = useMaterialUIController();
  const { darkMode,  miniSidenav, direction, layout } = controller;
  const [rtlCache, setRtlCache] = useState(null);
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const connectedUser = useSelector(selectCurrentUser);
  // Cache for the rtl
  useEffect(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });
    setRtlCache(cacheRtl);
  }, []); // This effect runs only once when the component mounts

  // For layout handling
  useEffect(() => {
      if ((pathname.includes("profil") || pathname.includes("Distibutions")) && layout !== "dashboard") {
          setLayout(dispatch, "dashboard");
      } else if (!pathname.includes("profil") && !pathname.includes("Distibutions") && layout === "dashboard") {
          setLayout(dispatch, "");
      }
  }, [pathname, layout, dispatch]); 

  const sidRoutes = useMemo(() => ([{
    type: "collapse",
    name: "profil",
    key:  "profil",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profil",
    access : ["SUPPER_ADMIN","PARTNER","USER"]
  },
  {
    type: "collapse",
    name: "Mes commandes",
    key:  "Commandes",
    route: "/profil/Commandes",
    icon:<Icon fontSize="small">shopping_cart</Icon>,
    access : ["SUPPER_ADMIN","PARTNER","USER"]
  },
  {
    type: "collapse",
    name: "Mes achâts",
    key:  "achâts",
    route: "/profil/achâts",
    icon:<Icon fontSize="small">shopping_bag</Icon>,
    access : ["SUPPER_ADMIN","PARTNER","USER"]
  },
  
  {
    type: "collapse",
    name: "Distibutions",
    key:  "Distibutions",
    icon: <Icon fontSize="small">local_shipping</Icon>,
    access : ["SUPPER_ADMIN","PARTNER"],
    collapse: [
      {
        type: "collapse",
        name: "Mes informations",
        key:  "Informations",
        icon: <Icon fontSize="small">settings</Icon>,
        route: "Distibutions/Informations",
        access : ["SUPPER_ADMIN","PARTNER"]
      },
      {
        type: "collapse",
        name: "Produits-commercialisé",
        key:  "Produits",
        icon: <Icon fontSize="small">reorder</Icon>,
        route: "Distibutions/Produits",
        access : ["SUPPER_ADMIN","PARTNER"]
      },
      {
        type: "collapse",
        name: "Commandes Clients",
        key:  "Commandes-Clients",
        route: "Distibutions/Commandes-Clients",
        icon:<Icon fontSize="small">shopping_basket</Icon>,
        access : ["SUPPER_ADMIN","PARTNER"]
      },
      {
        type: "collapse",
        name: "Mes ventes",
        key:  "ventes",
        route: "Distibutions/ventes",
        icon:<Icon fontSize="small">inventory</Icon>,
        access : ["SUPPER_ADMIN","PARTNER"]
      }
    ]
  }]), []);

  const filterRoutesByAccess = (routes, userRole) => {
    return routes.filter(route => route.access.includes(userRole))
      .map(route => ({
        ...route,
        collapse: route.collapse ? filterRoutesByAccess(route.collapse, userRole) : []
      }));
  };
  
  const filteredRoutes = useMemo(() => filterRoutesByAccess(sidRoutes, connectedUser?.isAdmin), [sidRoutes, connectedUser]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };
  
  return direction === "rtl" ? (
    <CacheProvider value={rtlCache}>
      <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
        <CssBaseline />
        <Alert/>
        {layout === "dashboard" && (
            <Sidenav
              color="primary"
              brand={!darkMode ? brandDark : brandWhite}
              brandName="Granitex"
              routes={filteredRoutes}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
        )}
        {routes()}
      </ThemeProvider>
    </CacheProvider>
    ) : (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      <Alert/>
      {layout === "dashboard" && (
            <Sidenav
              color="primary"
              brand={!darkMode ? brandDark : brandWhite}
              brandName="Granitex"
              routes={filteredRoutes}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
        )}
      {routes()}
    </ThemeProvider>
  );
};

export default App;